<template>
  <div v-if="$vuetify.breakpoint.xsOnly">
    <certificado-editar-form @success="success"></certificado-editar-form>
  </div>
  <v-container fluid grid-list-xl v-else>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <div>
            <certificado-editar-form @success="success"></certificado-editar-form>
          </div>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    components: {
      'certificado-editar-form': require('./CertificadoEditarForm').default
    },

    methods: {
      success(data) {
        this.$router.go(-1)
      }
    }
  }
</script>
